import { Outlet } from "react-router-dom";

const LabourLawRoot = () => {
  return <Outlet />;
};

export default LabourLawRoot;
